import React, { useState } from 'react';
import './Header.css';
import { Sidebar } from 'primereact/sidebar';
import { Button } from 'primereact/button';
import { Menu } from 'primereact/menu';

export default function Header() {
    const [visible, setVisible] = useState(false);
    const items = [
        // {
        //     label: 'Dashboard',
        //     icon: 'pi pi-home',
        //     url: '/admin/dashboard',
        // },
        {
            label: 'Job Postings',
            icon: 'pi pi-file',
            items: [
                {
                    label: 'List Job Postings',
                    icon: 'pi pi-list',
                    url: '/admin/job-posting',
                },
                {
                    label: 'Create Job Posting',
                    icon: 'pi pi-plus',
                    url: '/admin/job-posting/create',
                },
            ],
        },
    ];

    const customHeader = <>Menu</>;
    return (
        <header className="px-3 py-2 b-primary flex align-items-center">
            <div className="grid m-0">
                <div className="flex align-items-center">
                    <Button
                        className="mr-3 text-white sm:block lg:hidden"
                        rounded
                        icon="pi pi-bars"
                        text
                        onClick={setVisible}
                    ></Button>
                    <p className="flex align-items-center p-0 m-0">
                        <span className="text-2xl font-semibold border-right-1 mr-3 pr-3 text-100">
                            Bhrikuti Stock Broking Company
                        </span>
                        <span className="text-100 font-light">
                            Career Portal Admin
                        </span>
                    </p>
                </div>
            </div>
            {/* Sidebar */}
            <Sidebar
                visible={visible}
                onHide={() => {
                    setVisible(false);
                }}
                header={customHeader}
            >
                <Menu
                    model={items}
                    className="w-full"
                    pt={{ root: { style: { border: 'none' } } }}
                ></Menu>
                <Button label="Sign Out"></Button>
            </Sidebar>
        </header>
    );
}
